import type { MyOrganization } from '../store/types'
import { sendSetCurrentOrganization } from '../api/ws'
import { useAppStore } from '../store/app'
import './OrgPickerDropdown.css'

export function OrgPickerDropdown({
  orgs,
  onClose,
}: {
  orgs: MyOrganization[]
  onClose: () => void
}) {
  const attentionByOrg = useAppStore((s) => s.attentionByOrg)

  function select(id: string) {
    sendSetCurrentOrganization(id)
    onClose()
  }

  return (
    <>
      <div className="org-picker-backdrop" onClick={onClose} />
      <div className="org-picker-dropdown">
        {orgs.map((org) => {
          const a = attentionByOrg[org.id]
          // One number per household: approvals waiting + rooms with unread.
          // Shown on OTHER households only — the current one's items are already
          // reachable through the bell, and a chip there would just be noise.
          // This is the cross-household "B wants you while you're in A" signal.
          const count = a ? a.asks + a.unread_rooms + (a.unread_threads ?? 0) + (a.suggestions ?? 0) : 0
          const showChip = !org.is_current && count > 0
          return (
            <button
              key={org.id}
              className={`org-picker-dropdown__row${org.is_current ? ' org-picker-dropdown__row--current' : ''}`}
              onClick={() => select(org.id)}
              disabled={org.is_current}
            >
              <span className="org-picker-dropdown__name">{org.name}</span>
              {showChip && (
                <span
                  className="org-picker-dropdown__count"
                  aria-label={`${count} waiting in ${org.name}`}
                >
                  {count > 99 ? '99+' : count}
                </span>
              )}
              {org.is_current && <span className="org-picker-dropdown__check">✓</span>}
            </button>
          )
        })}
      </div>
    </>
  )
}
